/**
 * Custom Web Component: <buy-now-button>
 * Handles direct Buy Now checkout flow with validation and Prestige theme loading state.
 */
if (!window.customElements.get('buy-now-button')) {
  class BuyNowButton extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.handleClickBound = this.handleClick.bind(this);
      this.button?.addEventListener('click', this.handleClickBound);
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.handleClickBound);
    }

    get form() {
      const formId = this.getAttribute('form');
      if (formId) {
        return document.getElementById(formId) || document.forms[formId];
      }
      return this.closest('form') || (formId ? document.querySelector(`form#${formId}`) : null);
    }

    async handleClick(event) {
      event.preventDefault();

      if (this.button?.getAttribute('aria-busy') === 'true' || this.button?.disabled) {
        return;
      }

      const form = this.form;
      if (!form) {
        console.error('Associated product form not found for buy-now-button');
        return;
      }

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      this.button.setAttribute('aria-busy', 'true');
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

      try {
        const formData = new FormData(form);

        // Ensure active variant id is properly passed
        const idInput = form.querySelector('[name="id"]') || form.elements['id'];
        if (idInput && idInput.value) {
          formData.set('id', idInput.value);
        }

        const rootRoute = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${rootRoute}cart/add.js`, {
          method: 'POST',
          body: formData,
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        const data = await response.json();

        if (response.ok) {
          window.location.href = `${rootRoute}checkout`;
        } else {
          document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
          this.button.removeAttribute('aria-busy');
          const errorMessage = data.description || data.message || 'Error processing request';
          alert(errorMessage);
        }
      } catch (error) {
        console.error('Buy Now error:', error);
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
        this.button?.removeAttribute('aria-busy');
        alert('An unexpected error occurred. Please try again.');
      }
    }
  }

  window.customElements.define('buy-now-button', BuyNowButton);
}
